module.exports = __webpack_public_path__ + "static/img/UBIDOMO_slide-3-1500x630.4b4dbecc.jpg";